import script from "./BillingCreateEn.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingCreateEn.vue?vue&type=script&setup=true&lang=js"

import "./BillingCreateEn.vue?vue&type=style&index=0&id=35b70284&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b70284"]])

export default __exports__